import type { ComponentType } from 'react'
import { FollowupVisitTopics } from './FollowupVisitTopics'

/**
 * Per-type renderers for artifact "specials" (typed structured artifacts —
 * `artifacts.specials` on the wire, each carrying a `type` discriminator).
 *
 * The wire shape is deliberately loose (`{ type: string }` + passthrough), so a
 * renderer narrows its special with the matching strict schema from
 * `@behuman/core-contract` before rendering and renders nothing when the
 * payload doesn't validate. A special whose `type` has no entry here renders
 * nothing — old clients degrade silently when new special types ship.
 */
export interface SpecialViewProps {
  special: { type: string }
}

const SPECIAL_COMPONENTS: Record<string, ComponentType<SpecialViewProps>> = {
  'followup-visit-topics': FollowupVisitTopics,
}

export function getSpecialComponent(type: string): ComponentType<SpecialViewProps> | undefined {
  return SPECIAL_COMPONENTS[type]
}
